import React from 'react'
import { Sparkles, Server, GitMerge, BookOpen } from 'lucide-react'
import type { Mode } from './types'

const MODE_TABS: { mode: Mode; label: string; icon: React.ReactNode }[] = [
  { mode: 'ai',          label: 'AI Analysis',        icon: <Sparkles size={11} /> },
  { mode: 'pipeline',    label: 'Pipeline',           icon: <GitMerge size={11} /> },
  { mode: 'readership',  label: 'Readership Insights',icon: <BookOpen size={11} /> },
  { mode: 'endpoints',   label: 'Endpoints',          icon: <Server size={11} /> },
]

export function ModeToggle({ mode, onChange }: { mode: Mode; onChange: (m: Mode) => void }) {
  return (
    <div className="flex items-center gap-0 rounded border border-line bg-surface text-[10px] font-bold uppercase tracking-widest overflow-hidden">
      {MODE_TABS.map(({ mode: m, label, icon }) => (
        <button
          key={m}
          type="button"
          onClick={() => onChange(m)}
          className={`flex items-center gap-1.5 px-3 py-1.5 transition-colors ${
            mode === m
              ? 'bg-fg text-canvas'
              : 'text-fg-secondary hover:text-fg hover:bg-fill'
          }`}
        >
          {icon}
          {label}
        </button>
      ))}
    </div>
  )
}
